import {
  //   ApiGetRequest,
  ApiPostRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Laporan Piutang',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Laporan Kartu Piutang',
        href: '/adm/fin/laporan/kartu-piutang',
        active: true,
      },
    ],
    form: {
      periode: '',
    },
    report: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changePiutang(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getPiutang({ commit, state }) {
    commit('changePiutang', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/laporan/piutang`, data.form);
    commit('changePiutang', {
      report: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },
};
